import React, { useState, useEffect, useRef } from 'react';
import { Link, Redirect } from 'react-router-dom';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import Form from '../../../adminpanel/components/commonComponents/Form.v2';
import ReCAPTCHA from 'react-google-recaptcha';

const ForgotPassword = () => {
	let string = <ul className="list-group">
		<li className="list-group-item tx-bold bd-x-0 bd-y-0">Password Requirements:</li>
		<li className="list-group-item bd-x-0 bd-y-0">-Must be 8 characters or longer.</li>
		<li className="list-group-item bd-x-0 bd-y-0">-Must contain at least 1 lowercase alphabet.</li>
		<li className="list-group-item bd-x-0 bd-y-0">-Must contain at least 1 uppercase alphabet.</li>
		<li className="list-group-item bd-x-0 bd-y-0">-Must contain at least 1 numeric character.</li>
		<li className="list-group-item bd-x-0 bd-y-0">-Must contain at least 1 special character.</li>
	</ul>
	const [formData, setFormData] = useState({
		"userPassword": { "name": "userPassword", "label": "New Password*", "type": "password", },
		"confirmPassword": { "name": "confirmPassword", "label": "Confirm New Password*", "type": "password", },
	})
	const [error, setError] = useState(string);
	const [isLoading, setIsLoading] = useState(false);
	const [isError, setIsError] = useState(false);
	const [redirectPath, setRedirectPath] = useState(null);
	const reCaptchaRef = useRef();
	let reCaptchaValue = null;

	useEffect(() => {
		// load icon for error
		feather.replace();
	}, [error]);
	
	const recaptchaHandle = (value) => {
		if (value !== null) {
			reCaptchaValue = value;
		} else reCaptchaValue = null;
	}

	const passwordValidate = (value, inputNumber) => {
		const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
		let passwordFormArray = jQuery('#resetPassword_Form').serializeArray();
		if (inputNumber === 'firstInput') {
			if (strongRegex.test(value) === false) {
				setError(string);
				setIsError(true);
				setFormData((prevState) => ({
					...prevState,
					['userPassword']: { ...prevState['userPassword'], "errorFlag": true },
				}));
			} else {
				if (passwordFormArray[1].value === value) {
					setError('');
					setIsError(false);
					setFormData((prevState) => ({
						...prevState,
						['userPassword']: { ...prevState['userPassword'], "errorFlag": false },
						['confirmPassword']: { ...prevState['confirmPassword'], "errorFlag": false },
					}));
				} else if (passwordFormArray[1].value !== '' && value !== '' && passwordFormArray[1].value !== value) {
					setError('Passwords do not match');
					setIsError(true);
					setFormData((prevState) => ({
						...prevState,
						['userPassword']: { ...prevState['userPassword'], "errorFlag": false },
						['confirmPassword']: { ...prevState['confirmPassword'], "errorFlag": true },
					}));
				} else {
					setError(string);
					setIsError(false);
					setFormData((prevState) => ({
						...prevState,
						['userPassword']: { ...prevState['userPassword'], "errorFlag": false },
					}));
				}
			}
		} else if (inputNumber === 'secondInput') {
			if (passwordFormArray[0].value !== value) {
				setError('Passwords do not match');
				setIsError(true);
				setFormData((prevState) => ({
					...prevState,
					['confirmPassword']: { ...prevState['confirmPassword'], "errorFlag": true },
				}));
			} else if (passwordFormArray[0].value !== '' && value !== '' && passwordFormArray[0].value === value) {
				setError('');
				setIsError(false);
				setFormData((prevState) => ({
					...prevState,
					['confirmPassword']: { ...prevState['confirmPassword'], "errorFlag": false },
				}));
			} else {
				setError(string);
				setIsError(true);
				setFormData((prevState) => ({
					...prevState,
					['confirmPassword']: { ...prevState['confirmPassword'], "errorFlag": true },
				}));
			}
		}
	}

	const handleForm = (event) => {
		if (event.target.name === "userPassword") {
			passwordValidate(event.target.value.trim(), 'firstInput');
		} else if (event.target.name === "confirmPassword") {
			passwordValidate(event.target.value.trim(), 'secondInput');
		}
	}

	const formSubmission = (event) => {
		event.preventDefault();
		setIsLoading(true);
		let formValues = jQuery('#resetPassword_Form').serializeArray();
		let currentValues = JSON.parse(window.localStorage.getItem("validParams"));
		if (currentValues.userName !== undefined && currentValues.userName !== null && currentValues.userName !== '') {
			let params = {
				companyName: currentValues.companyName,
			}
			let data = {
				newPassword: formValues[0]['value'].trim(),
				userName: currentValues.userName,
				token: reCaptchaValue,
			}
			process.env.recaptcha === "false" ? delete data.token : null;
			CallAPI('POST', "/app/userConfig/updateUserPassword", data, params, null, function (response) {
				if (response.Status === "Password Updated!") {
					delete currentValues.userName;
					window.localStorage.setItem('validParams', JSON.stringify(currentValues));
					setIsLoading(false);
					alert('Password Reset Successfully!');
					process.env.recaptcha === "true" ? reCaptchaRef.current.reset() : null;
					setRedirectPath('/login');
				} else {
					alert('There was some problem while resetting the password.');
					process.env.recaptcha === "true" ? reCaptchaRef.current.reset() : null;
				}
			})
		} else {
			process.env.recaptcha === "true" ? reCaptchaRef.current.reset() : null;
			alert('Please, enter Email to reset password.');
			setRedirectPath('/login');
		}
	}

	const error_alert = (
		<div className={`alert alert-outline alert-${isError ? 'danger' : 'primary'} d-flex justify-content-center align-items-center`} role="alert">
			<i data-feather="alert-circle" className="mg-r-10"></i> {error}
		</div>
	);
	const form = <Form label_array={formData} handleForm={handleForm} />;

	if (redirectPath) {
		return <Redirect to={redirectPath} />
	}
	return (
		<>
			<h4 className="tx-center">To reset the password,</h4>
			<h4 className="tx-center">Please contact your administrator.</h4>
			<h5 className="tx-center mg-b-20 mg-t-20">admin@rockmetric.com</h5>
			{/* <h3 className="tx-center mg-b-20">Password Reset</h3>
			{error ? error_alert : null}
			<form autoComplete="off" data-parsley-validate="" data-parsley-trigger="change" noValidate="" id="resetPassword_Form" onSubmit={formSubmission}>
				{form}
				<input type="hidden" name="csrf" value="9002d9cd604829e57ca059215066cf46" id="csrf" />
				{process.env.recaptcha === "true" ?
					<ReCAPTCHA
						ref={reCaptchaRef}
						style ={{display: 'inline-block'}}
						sitekey={process.env.SITE_KEY}
						onChange={recaptchaHandle}
					/>
					: null}
				<button
					type="submit"
					name="submit"
					id="submit"
					className={`btn btn-primary btn-block ${process.env.recaptcha === "true" ? "mg-t-10" : null}`}
					disabled={formData.userPassword.errorFlag === false && formData.confirmPassword.errorFlag === false ? false : true}
				>
					Submit
					{isLoading ? (
						<span className="spinner-border spinner-border-sm mg-l-10" role="status" aria-hidden="true" />
					) : null}
				</button>
			</form> */}
			{/* <div className="divider-text">OR</div>
			<button className="btn btn-outline-primary btn-block">Contact Admin</button> */}
			<div className="mg-t-20 tx-center">
				<Link to="/login">Return to log in</Link>
			</div>
		</>
	);
};

export default ForgotPassword;
